// removed by extract-text-webpack-plugin
module.exports = {"Header":"Form__Header__3LYT5","Form":"Form__Form__2zwZf","moveSide":"Form__moveSide__3_K_-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Form.css
// module id = 133
// module chunks = 3